import type { PosCartRepository, FetchPosCartItemsArgs } from '../../domain/interfaces/PosCartRepository';
import type { PosCartItem } from '../../domain/models/PosCartItem';
import type { ProductDetailRepository } from '@/features/pdp/domain/interfaces/ProductDetailRepository';
import type { CustomizationRepository } from '@/features/customization/domain/interfaces/CustomizationRepository';
import { createCustomizationService, type CustomizationService } from '@/features/customization/application/services/CustomizationService';

export class PosCartService {
  private readonly customizationService: CustomizationService;

  constructor(
    private readonly repository: PosCartRepository,
    private readonly pdpRepository: ProductDetailRepository,
    customizationRepository: CustomizationRepository
  ) {
    this.customizationService = createCustomizationService(customizationRepository);
  }

  async getPosCartItems(args: FetchPosCartItemsArgs): Promise<PosCartItem[]> {
    return this.repository.fetchPosCartItems(args);
  }

  async getProductDetail(designId: string, params?: { customizationId?: number; size?: string }) {
    return this.pdpRepository.fetchProductDetail(designId, params);
  }

  getCustomizationService(): CustomizationService {
    return this.customizationService;
  }
}
